















































































































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Paging from 'biz-ts/src/api/Paging';
import ProductActivation from "@/model/ProductActivation";
import PaginationTable from "@/component/Table/pagination-table.vue";
import productModule from "@/store/module/ProductModule";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";
import WarnDialog from "@/component/Dialog/warn-dialog.vue";
import VueQrcode from 'vue-qrcode';
import ProductUtil from "@/module/device/ProductUtil";
import ProductActivationApi, {
  PactBatchEditForm,
  PactBatchGenerateForm,
  PactPqForm
} from "@/module/device/ProductActivationApi";
import ProductTestActiveCode from "@/view/device-manage/product/test-active-code.vue";
import SingleDayColumn from "@/component/Table/single-day-column.vue";
import _ from "lodash";
import Device from "@/model/Device";
import {MessageType} from "element-ui/types/message";
import {BatchResult} from "biz-ts/src/api/BatchActionReturn";
import {handleBatchReturn} from "@/util/HandleBatchReturn";
import IdColumn from "@/component/Table/id-column.vue";
import BoolColumn from "@/component/Table/bool-column.vue";
import EditDialog from "@/component/Crud/edit-dialog.vue";
import BoolSelect from "@/component/Select/bool-select.vue";
import {handleClipboard} from '@/util/clipboard';

@Component({
  components: {
    BoolSelect,
    EditDialog,
    BoolColumn,
    IdColumn,
    RefreshButton,
    PaginationTable,
    CreateDialog,
    DeleteDialog,
    ConfirmDialog,
    WarnDialog,
    VueQrcode,
    ProductTestActiveCode,
    SingleDayColumn,
  },
})
export default class ProductActivationView extends Vue {

  private pactApi = Container.get(ProductActivationApi)

  @Ref()
  private ptable!: PaginationTable

  private selection() {
    // @ts-ignore
    return this.ptable?.table?.selection
  }

  private get product() {
    return productModule.active
  }

  private lodash = _

  private async export2excel(options: { isPrinted: boolean } | undefined = undefined) {
    // @ts-ignore
    const selection: Array<ProductActivation> = this.ptable.table.selection
    if (_.isEmpty(this.selection())) {
      this.$message.warning('请选择至少一行')
      return
    }
    const data = selection.map(pact => {
      return [pact.sequence, this.qrcode(pact)]
    })
    import('@/util/export2excel').then(excel => {
      const tHeader = ['序列', '设备二维码']
      excel.export_json_to_excel({
        header: tHeader,
        data,
        filename: "激活码列表",
      })
    })
    if (options) {
      this.initBatchEditForm()
      this.batchEditForm.isPrinted = options.isPrinted
      await this.batchEdit()
      this.refresh()
    }
  }

  private paging = new Paging<ProductActivation>()

  private pact = new ProductActivation()

  private qrcode(pact: ProductActivation) {
    return ProductUtil.qrcode(this.product.key, this.product.natureKey, pact.activeCode)
  }

  private pqForm = new PactPqForm(this.product.id)

  private refresh() {
    this.ptable?.refresh()
  }

  private async search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  private async getPaging() {
    return this.pactApi.paging(this.pqForm)
  }

  @Ref()
  private batchGenDialog!: CreateDialog

  private batchGenForm = new PactBatchGenerateForm(this.product.id)

  private async initBatchGenForm() {
    this.batchGenForm.init()
  }

  private async batchGenerate() {
    await this.pactApi.batchGenerate(this.batchGenForm)
  }

  @Ref()
  private batchEditDialog!: EditDialog

  private batchEditForm = new PactBatchEditForm()

  private onBatchEditBtnClick() {
    if (_.isEmpty(this.selection())) {
      this.$message.warning('请选择至少一行')
      return
    }
    this.batchEditDialog.open()
  }

  private async initBatchEditForm() {
    this.batchEditForm = {
      ids: this.selection().map((it: Device) => {
        return it.id
      })
    }
  }

  private async batchEdit() {
    await this.pactApi.batchEdit(this.batchEditForm)
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private async handleDeleteClick(pact: ProductActivation) {
    this.pact = pact
    this.deleteDialog.open()
  }

  private async deleteAct() {
    await this.pactApi.delete(this.pact.id)
  }

  @Ref()
  private batchDeleteDialog!: DeleteDialog

  private deletableSelection() {
    return this.selection()?.filter((it: ProductActivation) => {
      return it.deletable
    })
  }

  private undeletableSelection() {
    return this.selection()?.filter((it: ProductActivation) => {
      return !it.deletable
    })
  }

  private onBatchDeleteBtnClick() {
    if (_.isEmpty(this.selection())) {
      this.$message.warning('请选择至少一行')
      return
    }
    this.batchDeleteDialog.open()
  }

  private async batchDelete() {
    const rt = await this.pactApi.batchDelete(
        this.selection().map((it: Device) => {
          return it.id
        })
    )

    let title = ''
    let type: MessageType = 'error'
    switch (rt.result) {
      case BatchResult.NO_DATA:
        title = "无数据删除"
        type = "warning"
        break
      case BatchResult.SUCCESS:
        title = "批量删除成功"
        type = "success"
        break
    }

    handleBatchReturn({
      successData: rt.successData,
      title: title,
      type: type,
    })
  }

  private copy = handleClipboard
}
